import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import Loader from "../../components/Loader";

// --- Static Kitty Stats ---
const kittyStatsData = [
  { label: "Total Kitties", value: 15 },
  { label: "Active Kitties", value: 8 },
  { label: "Completed Kitties", value: 5 },
  { label: "Pending Payments", value: 2 },
];

// --- Static Kitty Contribution Data (Monthly) ---
const kittyContributionData = [
  { month: "Jan", contribution: 2000, payout: 0 },
  { month: "Feb", contribution: 2000, payout: 0 },
  { month: "Mar", contribution: 2000, payout: 10000 },
  { month: "Apr", contribution: 2000, payout: 0 },
  { month: "May", contribution: 2000, payout: 0 },
  { month: "Jun", contribution: 2000, payout: 0 },
  { month: "Jul", contribution: 2000, payout: 0 },
];

// --- Static Kitty Activity Data ---
const kittyActivityData = [
  { month: "Jan", activities: 12 },
  { month: "Feb", activities: 15 },
  { month: "Mar", activities: 20 },
  { month: "Apr", activities: 18 },
  { month: "May", activities: 25 },
  { month: "Jun", activities: 30 },
  { month: "Jul", activities: 22 },
];

export default function CustomerDashboard({ user: propUser }) {
  const user = propUser || JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // simulate API delay
    const timeout = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timeout);
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="p-6 flex-1 bg-gray-100 min-h-screen">
      {/* Welcome */}
      <h1 className="text-3xl font-bold mb-6 text-gray-800">
        Welcome{" "}
        {user?.name
          ? user.name.charAt(0).toUpperCase() + user.name.slice(1)
          : "Customer"}
        !
      </h1>

      {/* Kitty Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {kittyStatsData.map((stat) => (
          <div
            key={stat.label}
            className="bg-white p-5 rounded-xl shadow flex items-center justify-between hover:shadow-lg transition-all"
          >
            <div className="flex items-center">
              <div className="bg-indigo-100 p-3 rounded-full mr-4" />
              <div>
                <p className="text-sm text-gray-500">{stat.label}</p>
                <p className="text-2xl font-semibold text-gray-800">{stat.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Kitty Contributions */}
        <div className="bg-white p-6 rounded-xl shadow">
          <h2 className="text-xl font-semibold mb-4 text-gray-700">
            Monthly Kitty Contributions & Payouts
          </h2>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart
              data={kittyContributionData}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="contribution"
                stroke="#6366F1"
                strokeWidth={2}
                name="Contribution"
              />
              <Line
                type="monotone"
                dataKey="payout"
                stroke="#10B981"
                strokeWidth={2}
                name="Payout"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Kitty Activities */}
        <div className="bg-white p-6 rounded-xl shadow">
          <h2 className="text-xl font-semibold mb-4 text-gray-700">
            Monthly Kitty Activity
          </h2>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart
              data={kittyActivityData}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="activities" fill="#6366F1" name="Activities" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
